import { FormControlLabel, Switch, switchClasses, Typography, useMediaQuery } from "@mui/material";
import React from "react";
import { memberTheme } from "../memberTheme";

const ToggleSwitch = (props: {
  style?: React.CSSProperties;
  label: string;
  switchValue: boolean;
  toggle: (_: boolean) => void;
}) => {
  const handleSwitchChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    props.toggle(e.target.checked);
  };

  const isMobile = useMediaQuery(memberTheme.breakpoints.down("sm"));

  if (isMobile && props.switchValue) {
    return null;
  }

  return (
    <FormControlLabel
      control={
        <Switch
          checked={props.switchValue}
          onChange={handleSwitchChange}
          sx={{
            [`& .${switchClasses.switchBase}.${switchClasses.checked}`]: {
              color: memberTheme.palette.primary.dark,
            },
            [`& .${switchClasses.switchBase}.${switchClasses.checked} + .${switchClasses.track}`]: {
              backgroundColor: memberTheme.palette.primary.dark,
            },
          }}
        />
      }
      label={
        <Typography variant="caption" sx={{ fontFamily: memberTheme.typography.fontFamily }}>
          {" "}
          {props.label}
        </Typography>
      }
      sx={{
        backgroundColor: memberTheme.palette.greys.grey300,
        borderRadius: "4px",
        padding: "8px, 8px, 8px, 4px",
        width: "174px",
        height: "40px",
      }}
    />
  );
};

export default ToggleSwitch;
